<template>
  <a-modal
    :title="title"
    :width="600"
    :visible="visible"
    centered
    :maskClosable="false"
    :destroyOnClose="true"
    :forceRender="true"
    @ok="handleSubmit"
    @cancel="handleCancel()"
    :confirmLoading="confirmLoading"
  >
    <a-spin :spinning="confirmLoading">
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        @submit="handleSubmit"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-form-model-item label="平台名称" prop="platformType">
          <a-select v-model="form.platformType" placeholder="请选择平台名称">
            <a-select-option
              :value="item.value"
              v-for="(item, index) in groupList"
              :key="index"
            >
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="账户">
          <a-input v-model="form.account" placeholder="请输入账户" />
        </a-form-model-item>
        <a-form-model-item label="appKey" prop="appKey">
          <a-input v-model="form.appKey" placeholder="请输入appKey" />
        </a-form-model-item>
        <a-form-model-item label="appSecret" prop="appSecret">
          <a-input v-model="form.appSecret" placeholder="请输入appSecret" />
        </a-form-model-item>
        <a-form-model-item label="状态" prop="status">
          <a-radio-group v-model="form.status" button-style="solid">
            <a-radio-button
              :value="item.value"
              v-for="(item, index) in statusList"
              :key="index"
            >
              {{ item.label }}
            </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
import { SettingSchool } from "@/api";
export default {
  components: {},
  data() {
    return {
      title: "",
      type: "",
      confirmLoading: false,
      visible: false,
      formData: {
        projectId: "",
        platformType: undefined,
        account: "", //账户
        appKey: "", //appKey
        appSecret: "", //appSecret
        status: "1",
      },
      form: {},
      statusList: [],
      groupList: [],
      rules: {
        platformType: [this.common.rulesReq("请选择平台")],
        appKey: [this.common.rulesReq("请输入appKey")],
        appSecret: [this.common.rulesReq("请输入appSecret")],
        status: [this.common.rulesReq("请选择状态")],
      },
    };
  },
  mounted() {},
  created() {},
  methods: {
    async open(type, data) {
      this.type = type;
      this.title = type == "edit" ? "编辑对接平台" : "添加对接平台";
      this.visible = true;
      this.form = JSON.parse(JSON.stringify(this.formData));
      this.form.schoolId = this.$store.state.user.schoolId;
      if (type == "edit" && data) {
        this.form = JSON.parse(JSON.stringify(data));
        this.form.status = data.status + "";
        delete this.form.createTime;
        delete this.form.updateTime;
        delete this.form.creatorId;
        delete this.form.version;
      }
      // 获取数据字典
      this.statusList = await this.common.getSysCodeType("SYS_STATUS");
      this.groupList = await this.common.getSysCodeType("DEVICE_SUPPLIER_CODE");
    },

    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let newForm = JSON.parse(JSON.stringify(this.form));

          this.submitSave(newForm);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    // 提交
    submitSave(data) {
      this.confirmLoading = true;
      console.log(data);
      SettingSchool.projectDataDockingCompanySave(data).then(res => {
        if (res.code == this.config.pubCode) {
          this.pubMsg.tipMessage(
            this.type == "edit" ? "修改成功！" : "添加成功！",
            "success"
          );
          this.handleCancel(1);
        }
        this.confirmLoading = false;
      });
    },
    handleCancel(data) {
      this.$emit("ok", data);
      this.visible = false;
      this.$refs.ruleForm.resetFields();
      this.form = JSON.parse(JSON.stringify(this.formData));
    },
  },
};
</script>
